import { CustomTableColumn } from "./custom-table-column";

export class LocationLinkTableColumn extends CustomTableColumn {
    idPath: string;

    constructor(label: string, path: string, idPath?: string) {
        super("locationName", label, path);
        this.idPath = idPath;
    }
}
